import type { SortDirection } from '@/components/table/useTablePreferences';

export function compareSortValues(
  a: string | number | Date | null | undefined,
  b: string | number | Date | null | undefined,
  direction: SortDirection
): number {
  const emptyA = a == null || a === '';
  const emptyB = b == null || b === '';
  if (emptyA && emptyB) return 0;
  if (emptyA) return 1;
  if (emptyB) return -1;

  let cmp = 0;
  if (a instanceof Date && b instanceof Date) {
    cmp = a.getTime() - b.getTime();
  } else if (typeof a === 'number' && typeof b === 'number') {
    cmp = a - b;
  } else {
    cmp = String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true });
  }
  return direction === 'asc' ? cmp : -cmp;
}
